<template>
    <div>
        <card-header title="Course Details" icon="fa-pencil"/>

        <card-toolbar>
            <button @click="$openCard('edit-course', {courseId: course.id}, card)"><i class="far fa-pencil"></i>Edit Details</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <course-tile :course="course" :card="card"/>

                <subheader-list-item title="Overview" icon="fa-align-left"/>
                <container-list-item>
                    <data-row title="Course Code" v-if="course.code">
                        <b-tag type="is-primary"><i class="far fa-tag ml-1 mr-1"></i> {{ course.code }}</b-tag>
                    </data-row>
                </container-list-item>

                <subheader-list-item title="Enrollments" icon="fa-users"/>

                <search-list-item @action="searchEnrollments"/>
                <separator-list-item/>

                <navigation-list-item
                    @click="$openCard('enrollments', {type: 'all', courseId: course.id}, card)"
                    title="All Enrollments"
                    :badge="counts.total | numeral('0,0')"
                    icon="fa-users"
                    :active="(child && child.definition.component === 'enrollments' && course.id === parseInt(child.props.courseId) && 'all' === child.props.type)"
                />
                <navigation-list-item
                    @click="$openCard('enrollments', {type: 'complete', courseId: course.id}, card)"
                    title="Completed"
                    :badge="counts.completed | numeral('0,0')"
                    icon="fa-check"
                    :active="(child && child.definition.component === 'enrollments' && course.id === parseInt(child.props.courseId) && 'complete' === child.props.type)"
                />
                <navigation-list-item
                    @click="$openCard('enrollments', {type: 'progress', courseId: course.id}, card)"
                    title="In Progress"
                    :badge="counts.in_progress | numeral('0,0')"
                    icon="fa-clock"
                    :active="(child && child.definition.component === 'enrollments' && course.id === parseInt(child.props.courseId) && 'progress' === child.props.type)"
                />
                <navigation-list-item
                    @click="$openCard('enrollments', {type: 'missing', courseId: course.id}, card)"
                    title="Missing Application(s)"
                    :badge="counts.missing_applications | numeral('0,0')"
                    icon="fa-exclamation-triangle has-text-warning"
                    :active="(child && child.definition.component === 'enrollments' && course.id === parseInt(child.props.courseId) && 'missing' === child.props.type)"
                />

                <subheader-list-item title="Reports" icon="fa-clipboard"/>

                <navigation-list-item
                    @click="$openCard('all-responses', {courseId: course.id}, card)"
                    title="Enrollment Course Responses"
                    icon="fa-comment"
                    :active="(child && child.definition.component === 'all-responses' && course.id === parseInt(child.props.courseId))"
                />

                <subheader-list-item title="Setup" icon="fa-cogs"/>

                <navigation-list-item
                    title="Course Outline"
                    icon="fa-list-alt"
                    @click="$openCard('course-outline', {courseId: course.id}, card)"
                    :active="(child && child.definition.component === 'course-outline' && course.id === parseInt(child.props.courseId))"
                />

                <navigation-list-item
                    title="Enrollment Options"
                    icon="fa-sliders"
                    @click="$openCard('course-configs', {courseId: course.id}, card)"
                    :active="(child && child.definition.component === 'course-configs' && course.id === parseInt(child.props.courseId))"
                />

<!--                <navigation-list-item title="Prerequisite Courses" icon="fa-chalkboard-user" @click=""/>-->

<!--                <navigation-list-item-->
<!--                    title="Enrollment Discounts"-->
<!--                    icon="fa-tags"-->
<!--                />-->

                <navigation-list-item
                    title="Certification Applications"
                    icon="fa-file-certificate"
                    @click="$openCard('course-applications', {courseId: course.id}, card)"
                    :active="(child && child.definition.component === 'course-applications' && course.id === parseInt(child.props.courseId))"
                />

<!--                <navigation-list-item-->
<!--                    title="Assigned Users"-->
<!--                    icon="fa-user-check"-->
<!--                />-->
            </card-list>
        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';
    import CourseTile from "../../components/tiles/CourseTile.vue";
    import ContainerListItem from "../../TIER/components/ContainerListItem.vue";
    import DataRow from "../../TIER/components/DataRow.vue";
    import SearchListItem from "../../TIER/components/SearchListItem.vue";
    import async from "async";

    export default {
        components: {SearchListItem, DataRow, ContainerListItem, CourseTile, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                course: {},
                enrollments: [],
                counts: {
                    total: null,
                    completed: null,
                    in_progress: null,
                    missing_applications: null,
                },
                confirmDelete: false,
                dirty: null,
            };
        },
        methods: {
            loadCourse: function(force) {
                this.$emit('loading', true);

                async.parallel([
                    (cb) => {
                        http.get('courses/new/' + this.props.courseId, {force}).then(response => { // TODO: temporary endpoint
                            if (!response.data.outline) response.data.outline = []; //TODO temp
                            this.course = response.data;
                            this.$emit('title', response.data.title);
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get(`courses/new/${this.props.courseId}/counts`, {force}).then(response => {
                            this.counts = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    if (err) {
                        console.log(err);
                    } else {
                        this.$emit('loading', false);
                    }
                })


            },
            submit: function() {
                this.$emit('loading', true);
                http.put('courses/' + this.props.courseId, this.course, {force: true}).then(response => {
                    this.$reloadCard('courses');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            searchEnrollments: function(query) {
                this.$openCard('enrollment-search', {query, courseId: this.props.courseId, type: 'all'}, this.card);
            },
            deleteCourse() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    http.delete('courses/' + this.props.courseId).then(response => {
                        this.$reloadCard('courses');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            },
            reload() {
                this.loadCourse(true);
            }
        },
        watch: {
            'props.courseId': function() {
                this.dirty = null;
                this.loadCourse();
            }
        },
        mounted() {
            this.loadCourse();
        }
    };
</script>
